import React from 'react';
import { FormattedMessage } from 'react-intl';
import getLangData from '../../../utils/getLangData';

export default class MenuItemText extends React.Component {
  render() {
    const { item, parentItem } = this.props;

    return (
      <>
        <span
          className='kt-menu__link-text'
          style={{ whiteSpace: 'nowrap', marginLeft: '15px' }}
        >
          {item.title}
        </span>

        {item.badge && (
          <span className='kt-menu__link-badge'>
            <span className={`kt-badge ${item.badge.type}`}>
              {item.badge.value}
            </span>
          </span>
        )}

        {item.submenu && (
          <i
            className={`icon-arrow-${getLangData().direction === 'rtl' ? 'left': 'right'}-warshatna `}
            style={{ fontSize: '13px', marginLeft: 'auto' }}
          />
        )}
      </>
    );
  }
}
